import $ from 'jquery';

function slideshow($slideshowContainer, customOptions) {
  const options = {
    nextClass: 'js-next-slide',
    previousClass: 'js-previous-slide',
    currentSlide: 0,
    timer: 0
  };

  if (customOptions) {
    $.extend(options, customOptions);
  }

  const $allSlides = $slideshowContainer.find('.js-slide-content');

  const $dots = $slideshowContainer.find('.js-slide-dot');
  let currentSlide = options.currentSlide;
  let timer;
  if (options.timer !== 0) {
    timer = setInterval(nextSlide, options.timer);
  }

  function resetTimer() {
    if (options.timer !== 0) {
      clearInterval(timer);
      timer = setInterval(nextSlide, options.timer);
    }
  }

  function nextSlide() {
    const newIndex = (currentSlide + 1) % $allSlides.length;
    changeSlide(newIndex);
  }

  function previousSlide() {
    const newIndex = (currentSlide - 1 + $allSlides.length) % $allSlides.length;
    changeSlide(newIndex);
  }

  function changeSlide(slideIndex) {
    $($allSlides[currentSlide]).removeClass('active');
    $($dots[currentSlide]).removeClass('active');
    currentSlide = slideIndex;
    $($allSlides[currentSlide]).addClass('active');
    $($dots[currentSlide]).addClass('active');
  }

  const $nextArrow = $('.' + options.nextClass);
  const $previousArrow = $('.' + options.previousClass);
  $dots.click(function() {
    const dotIndexClicked = $dots.index(this);
    changeSlide(dotIndexClicked);
    resetTimer();
  });

  $nextArrow.click(function() {
    nextSlide();
    resetTimer();
  });
  $previousArrow.click(function() {
    previousSlide();
    resetTimer();
  });
}

// exposition sous forme de module jQuery
$.fn.extend({
  slideshow: function(customOptions) {
    return this.each(function() {
      slideshow($(this), customOptions);
    });
  }
});

export default slideshow;
